import { render, staticRenderFns } from "./EditNewsDialog.vue?vue&type=template&id=2ec736ed&scoped=true&lang=pug&"
import script from "./EditNewsDialog.vue?vue&type=script&lang=ts&"
export * from "./EditNewsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./EditNewsDialog.vue?vue&type=style&index=0&id=2ec736ed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec736ed",
  null
  
)

export default component.exports